import { createSlice } from "@reduxjs/toolkit"; 

const navigationSlice = createSlice({
  name: "navigation",
  initialState: {
    lastEvent: null,
    isAnalyticsPage: false, 
  },
  reducers: {
    sendNavigationEvent: (state, action) => {
      state.lastEvent = action.payload;
    },
    enterAnalyticsPage: (state) => {
      state.isAnalyticsPage = true;
    },
    leaveAnalyticsPage: (state) => {
      state.isAnalyticsPage = false;
    },
  },
});

export const { sendNavigationEvent, enterAnalyticsPage, leaveAnalyticsPage } = navigationSlice.actions;
export default navigationSlice.reducer;
